import React from 'react'
import { useForm } from 'react-hook-form'
import CrudCreate from '~/components/CrudCreate'
import IWeaponBrand from '../interfaces/IWeaponBrand'
import Layout from '~/components/Layout'

export default function Create() {
  const {
    register,
    handleSubmit,
    control,
    setValue: setFormValue,
  } = useForm<IWeaponBrand>()

  const fields = [{ name: 'name', type: 'string' }]

  return (
    <Layout marginLayout={true}>
      <CrudCreate
        model={'weapon-brand'}
        fields={fields}
        register={register}
        handleSubmit={handleSubmit}
        control={control}
        messageSuccess={'Weapon brand successfully created!'}
        title={'Add weapon brand'}
        subheader={'Add weapon brand'}
        setFormValue={setFormValue}
      />
    </Layout>
  )
}
